import React from 'react';
import RentalFormTextField from '../RentalFormTextField';
import styles from './RentalForm.scss';

const RentalForm = props => (
  <div className={styles.rentalForm}>
    <RentalFormTextField
      fieldName="firstName"
      label="First Name"
      required
      type="text"
      {...props}
    />
    <RentalFormTextField
      fieldName="lastName"
      label="Last Name"
      required
      type="text"
      {...props}
    />
    <RentalFormTextField
      fieldName="email"
      label="Email"
      required
      type="text"
      {...props}
    />
    <RentalFormTextField
      fieldName="phoneNumber"
      label="Phone Number"
      required
      type="phone"
      {...props}
    />
  </div>
);

export default RentalForm;
